import { render, staticRenderFns } from "./AtopicDermatitisBodyModel.vue?vue&type=template&id=7c6d273c&scoped=true&"
import script from "./AtopicDermatitisBodyModel.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisBodyModel.vue?vue&type=script&lang=js&"
import style0 from "./AtopicDermatitisBodyModel.vue?vue&type=style&index=0&id=7c6d273c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6d273c",
  null
  
)

export default component.exports